var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPapelarias({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2056 40.4896C28.3732 40.4896 21.2148 39.3728 21.2148 37.9929V63.5889C21.2148 64.9689 28.3732 66.0856 37.2056 66.0856C46.038 66.0856 53.1964 64.9689 53.1964 63.5889V37.9929C53.1964 39.3728 46.038 40.4896 37.2056 40.4896Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2766 26.4209L25.0751 2.94287L16.9048 5.95304L28.8354 40.1174C30.1909 40.2458 31.69 40.3485 33.2766 40.4063V26.4145V26.4209Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4971 13.3855L22.1893 12.3906",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.108 20.8498L24.794 19.855",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7128 28.3077L27.405 27.3193",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 35.7723L30.0096 34.7839",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2766 18.4302V40.4127C34.5384 40.4641 35.8501 40.4897 37.2118 40.4897C38.7734 40.4897 40.2788 40.4512 41.703 40.387V18.4302H33.2766Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2766 18.4301L37.4867 10.7603L41.6968 18.4301H33.2766Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.754 40.4577C40.3974 40.4449 41.022 40.4192 41.6342 40.3936C41.022 40.4192 40.3974 40.4385 39.754 40.4577Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8175 24.919L46.7188 24.2451C45.6881 23.9177 44.5887 24.5082 44.2702 25.5672L41.6967 34.0522V40.387C43.3457 40.31 44.8948 40.1945 46.2753 40.0468L50.1043 27.4349C50.4291 26.3759 49.8482 25.2463 48.8175 24.919Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.725 24.245L48.8238 24.9189C49.1799 25.0345 49.4734 25.2463 49.7046 25.5158L53.2025 21.6071L51.3224 12.8911L44.951 18.9628L45.6694 24.2258C46.0067 24.1359 46.369 24.1359 46.725 24.2514V24.245Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3224 12.8848L49.2924 19.5726",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4809 36.0805C50.9789 36.5362 53.1964 37.2229 53.1964 37.9931C53.1964 39.373 46.038 40.4898 37.2056 40.4898C28.3732 40.4898 21.2148 39.373 21.2148 37.9931C21.2148 37.1908 23.6384 36.4784 27.405 36.0227",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapelarias);
export default __webpack_public_path__ + "static/media/Papelarias.f83f146bf1f9b871221b32b3bf3a34e7.svg";
export { ForwardRef as ReactComponent };